import moment from 'moment/min/moment-with-locales';

import { Component, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { ChangeThemeService } from '@shared/services/change-theme/change-theme.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { RouterEventsService } from '@core/services/router-events/router-events.service';
import { SpinnerWindowComponent } from './core/components/spinner-window/spinner-window.component';
import { TooltipModule } from 'primeng/tooltip';
import { ChatBotService } from '@shared/services/chat-bot/chat-bot.service';
import { ToastModule } from 'primeng/toast';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [
        ProgressSpinnerModule,
        RouterOutlet,
        SpinnerWindowComponent,
        ProgressSpinnerModule,
        TooltipModule,
        ToastModule
    ]
})

export class AppComponent implements OnDestroy {
  // isLanding: Boolean = this.route.snapshot.data['isLanding'];
  isLanding: Boolean = location.pathname.indexOf('public/') !== -1 || location.pathname.indexOf('shared/') !== -1 || location.pathname.indexOf('contact-login') !== -1 || location.pathname.indexOf('preview-customization') !== -1;
  skin: string;
  subscribers : any = {};
  app:any ={};
  loadAllSources: boolean = false;
  showSpinnerLoading: boolean = false;
  anotherPageText: string = '';
  constructor(
    private apiProperties: ApiPropertiesFactory,
    private apiService: ApiServiceService,
    private broadcastService: BroadcastService,
    private changeTheme: ChangeThemeService,
    private commonUtilsService: CommonUtilsService,
    private context: ContextFactory,
    private globalCfg: GlobalCfgFactory,
    private modalService: ModalServiceService,
    private registerMixtape: RegisterMixtapeService,
    private route: ActivatedRoute,
    private router: Router,
    private routerEventsService: RouterEventsService,
    private translate: AfTranslateFactory,
    private chatBotService: ChatBotService
  ) {
      this.registerMixtape.init();
      if(this.context.user && !this.chatBotService.loaded){
         this.chatBotService.initLandbot();
      }
      this.initEventSpinner();
      this.controllerEventRouter();
      // if(window.location.href.indexOf('login?target=root.dashboard') !== -1 || window.location.href.indexOf('login?target=%2Fdashboard') !== -1){
      //     window.open(window.location.origin, '_self');
      // }else{
          this.getProperties();
      // }
      this.routerEventsService.subscribe();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    this.modalService.close();
    let hasFolder : boolean = window.location.pathname.indexOf('folder') !== -1;
    let hasFavorites : boolean = window.location.pathname.indexOf('favorites') !== -1;
    let hasReports : boolean = window.location.pathname.indexOf('reports') !== -1;
    let hasEvaluation : boolean = window.location.pathname.indexOf('evaluation') !== -1;
    if(this.route.firstChild?.snapshot.data['componentName'] === 'evaluation' && hasEvaluation && !hasFolder && !hasFavorites && !hasReports){
        window.history.back();
    }
  }

  initEventSpinner(){
    this.subscribers.spinnerLoading = this.broadcastService.subscribe('spinnerLoading', ( data:any)=>{
      this.showSpinnerLoading = data.showSpinnerLoading;
      this.anotherPageText = data.text;
    });
  }

  controllerEventRouter(){
    this.subscribers.routerEventSubscribe = this.router.events.subscribe((event: any)=>{
      if (event instanceof NavigationEnd){
        let bodyApp: any = document.getElementById('centinela-app-template');
        if(bodyApp){
          bodyApp.classList.remove('common__app--dark');
        }
        if(this.route.firstChild?.snapshot.data['componentName'] === 'dashboardPanel'){
          bodyApp.classList.add('common__app--dark');
        }
      }
    })
  }

  async getDefaultLanguage(): Promise<void> {
    let browserLanguage:any = sessionStorage.getItem('selectLanguage');

    if (!browserLanguage || browserLanguage === 'null') {
      // Detecta el idioma del navegador
      browserLanguage = this.configureNavigatorLanguage() || this.apiProperties.defaultLanguage;
      browserLanguage = this.setDefaultUk(browserLanguage);
    }

    try {
      await this.translate.setDefaultLang(browserLanguage);
      await this.translate.setSiteTerms();
      this.getGlobalCfg();
    } catch (error) {
      console.error('Error al configurar el idioma por defecto:', error);
    }
  }

  configureNavigatorLanguage(){
    let navigatorLanguage: string = navigator.language;
    let browserLanguageSupported: boolean = this.apiProperties.availableLanguages.indexOf(navigatorLanguage) !== -1;
    if (!browserLanguageSupported) {
      let browserLanguage = navigatorLanguage.split('-')[0];
      navigatorLanguage = this.apiProperties.availableLanguages.find((item:any)=> item.indexOf(browserLanguage) === 0);
    }
    return navigatorLanguage;
  }

  setDefaultUk(browserLanguage: any){
    if(this.apiProperties.countryApi === 'UK' && browserLanguage === 'en-GB'){
      return 'taxwin_en-GB';
    }
    return browserLanguage;
  }

  getProperties(){
    this.apiService.getConfig().then((data)=>{
      this.apiProperties.setApiProperties(data);
      this.getDefaultLanguage();
    })
  }

  getGlobalCfg(){
    if(this.globalCfg.loaded){
      this.configureGlobalCfg();
    }else{
      this.apiService.getGlobal()
        .then((data:any)=>{
          this.globalCfg.setGlobalCfg(data.data);
          this.configureGlobalCfg();
        })
    }
  }

  configureGlobalCfg(){
    if(!this.isLanding){
      this.changeTheme.setAppColors();
    }
    // this.skin = this.isLanding?'landing':this.globalCfg.skin;
    this.skin = this.globalCfg.skin;
    this.initWithProperties();
    this.configureFavicon();
    let skinBody: string = this.isLanding?'landing':this.globalCfg.skin;
    document.body.classList.add('centinela-'+skinBody);

  }

  async initWithProperties(): Promise<void> {
    try {
      let browserLanguage = sessionStorage.getItem('selectLanguage');
      let browserLanguageSupported = false;

      // Detectar idioma del navegador si no hay guardado
      if (!browserLanguage || browserLanguage === 'null') {
        browserLanguage = this.configureNavigatorLanguage();
        browserLanguageSupported = Boolean(browserLanguage);
      } else {
        browserLanguageSupported = true;
      }

      // Si no está soportado, usar el idioma por defecto
      if (!browserLanguageSupported) {
        console.warn(
          `Browser language ${navigator.language} not supported. Defaulting to ${this.apiProperties.defaultLanguage}`
        );
        browserLanguage = this.apiProperties.defaultLanguage;
      }

      let languageKey = browserLanguage;
      this.translate.languagesUseBase(languageKey);

      // Configuración según skin (UI/theme)
      let availableJsonLanguages: any = [...this.apiProperties.availableLanguages];

      if (this.globalCfg.skin === 'uk-steel-blue' && languageKey === 'en-GB') {
        languageKey = 'taxwin_en-GB';
        availableJsonLanguages.push(languageKey);

      } else if (this.globalCfg.skin === 'steel-blue') {
        const product = this.context.settings?.defaultProduct;

        if (['bedrijfsst', 'blanqueo', 'whistle'].includes(product)) {
          languageKey = `${product}_${languageKey}`;
        } else {
          // Por defecto, AML
          const languageKeyConfigurated = languageKey === 'es-ES' ? 'en-US' : languageKey;
          languageKey = `blanqueo_${languageKeyConfigurated}`;
        }

        availableJsonLanguages.push(
          'bedrijfsst_en-US', 'bedrijfsst_fr-BE', 'bedrijfsst_nl-BE',
          'blanqueo_en-US', 'blanqueo_fr-BE', 'blanqueo_nl-BE',
          'whistle_en-US', 'whistle_fr-BE', 'whistle_nl-BE'
        );

      } else if (this.globalCfg.skin === 'dark-blue') {
        if (this.context.settings?.defaultProduct === 'denunc' && languageKey === 'fr-FR') {
          languageKey = 'denunc_fr-FR';
        }
        availableJsonLanguages.push(languageKey);

      } else if (this.globalCfg.skin === 'gm-law') {
        if (this.context.settings?.defaultProduct === 'denunc' && languageKey === 'it-IT') {
          languageKey = 'denunc_it-IT';
        }
        availableJsonLanguages.push(languageKey);
      }

      // Configurar moment.js
      moment.updateLocale(browserLanguage.split('-')[0], { week: { dow: 1 } });

      // Registrar idiomas disponibles
      this.translate.registerAvailableLanguageKeys(availableJsonLanguages);
      this.translate.preferredLanguage(languageKey);

      // Cargar idioma
      if (this.translate.hasLanguage(languageKey)) {
        this.translate.setLanguageToTranslate(languageKey);
        this.configureApp();
      } else {
        await this.translate.getTranslates(languageKey);
        this.configureApp();
      }
    moment.updateLocale(browserLanguage.split('-')[0], { week: { dow: 1 } });
    document.documentElement.lang = browserLanguage.split('-')[0]; // ← aquí
    } catch (error) {
      console.error('❌ Error en initWithProperties:', error);
    }
  }

  configureApp(){
    this.commonUtilsService.configCalendar();
    this.loadAllSources = true;
  }

  configureFavicon(){
    switch(this.globalCfg.skin){
      case 'icam-red':
          this.app.pagePreferences = {
          title: this.isLanding?'Consultas documentales - UGC':'Gestión del Conocimiento',
          fav: '../assets/img/favicon-icam.ico'
        }
        break;
      case 'steel-blue':
        this.app.pagePreferences = {
          title: this.isLanding?'Whistleblowing Channel':'GoComply',
          fav: '../assets/img/favicon-gocomply.ico'
        }
        break;
      case 'uk-steel-blue':
        this.app.pagePreferences = {
          title: 'Indicator FLM - TaxWin',
          fav: '../assets/img/favicon-Taxwin.ico'
        }
        break;
      case 'gm-law':
        this.app.pagePreferences = {
          title: 'Segnala',
          fav: '../assets/img/favicon-segnala.ico'
        }
        break;
      default:
        this.app.pagePreferences = {
          title: 'Centinela',
          fav: '../assets/img/favicon-lefebvre.ico'
        }
        break;
    }
    document.title = this.app.pagePreferences.title;
    this.isLanding?this.getGlobalIdentity():this.setFavicon(this.app.pagePreferences.fav);
  }

  getGlobalIdentity(){
    let targetSplit;
    let href:any = decodeURIComponent(window.location.href);
    let loginInfoSession:any = sessionStorage.getItem('loginInfo');
    let access:any = this.getAccess(href);
    if(location.pathname.indexOf('preview-customization') !== -1){
      let company: any = sessionStorage.getItem('companyPreviewCustomization');
      if(company){
        company = JSON.parse(company);
        let favicon = company?.favIcon?company.favIcon:null;
        this.configureCustomFavicon(favicon);
      }else{
        this.getGlobalCustom('company/globalcustomization', this.context.user.companyId);
      }
    }else if(href.indexOf('/public/concept/')!== -1){
      targetSplit = href.substring(href.indexOf('/public/concept/')+('/public/concept/').length, href.indexOf('?'));
      this.getGlobalCustom('concepts/publicconfigurationfavicon/concept', targetSplit);
    }else if(href.indexOf('/shared/concept-evaluated/')!== -1){
      let position1 = href.indexOf('concept-evaluated');
      let position = href.indexOf('/', position1)+1;
      let positionEnd = href.indexOf('/', position) !== -1?href.indexOf('/', position):href.length;
      let conceptObjectId = href.substring(position, positionEnd);
      //Este if es para quitar el & del id y transmitir posibles parámetros extra (como el access) que se puedan pasar en la url al ws.
      //Lo de limpiar el id es necesario, pero creo que el añadir el access no vale para nada, ya que el ws no usa el access
      if (conceptObjectId.indexOf('&') !== -1) {
        let id: any = conceptObjectId.split('&')[0];
        if (id.indexOf('/') !== -1) {
          id = id.split('/')[0];
        }
        conceptObjectId = id + '?' + conceptObjectId.split('&')[1];
      }
      this.getGlobalCustom('company/globalcustomization/byconceptobject', conceptObjectId);
    }else if(href.indexOf('/shared/task/') !== -1){
      this.configureTargetTask(href, 'task');
    }else if(href.indexOf('/shared/meeting/') !== -1){
      this.configureTargetTask(href, 'meeting');
    } else if((href.indexOf('/contact-login') !== -1 || href.indexOf('/public/monitoring') !== -1) && access){
      this.getGlobalCustom('concepts/publicconfigurationfavicon?access='+ encodeURIComponent(access), null);
    }else if(href.indexOf('/public/monitoring') !== -1 && loginInfoSession){
      let conceptObjectId = this.route.snapshot.queryParams['conceptObjectId'];
      if(!conceptObjectId){
        let loginInfo = JSON.parse(loginInfoSession.split('/'));
        if(loginInfo?.target?.targetType === 'ConceptObject'){
          conceptObjectId = loginInfo.target.targetId;
        }
      }
      this.getGlobalCustom('company/globalcustomization/byconceptobject', conceptObjectId);
    }else{
      this.setFavicon(this.app.pagePreferences.fav);
    }
  }

  getAccess(href: any){
    if(this.route.snapshot.queryParams['access']){
      return this.route.snapshot.queryParams['access'];
    }else if(href.indexOf('access=') !== -1){
      return href.split('access=')[1];
    }else{
      return null;
    }
  }

  configureTargetTask(href: any, type: any){
    let targetSplit: any = href.substring(href.indexOf('/shared/'+type+'/')+('/shared/'+type+'/').length,href.length);
    //Este if es para quitar el & del id y transmitir posibles parámetros extra (como el access) que se puedan pasar en la url al ws.
    //Lo de limpiar el id es necesario, pero creo que el añadir el access no vale para nada, ya que el ws no usa el access
    if (targetSplit.indexOf('&') !== -1){
      let id: any = targetSplit.split('&')[0];
      if(id.indexOf('/') !== -1){
        id = id.split('/')[0];
      }
      targetSplit = id + '?' + targetSplit.split('&')[1];
    }
    this.getGlobalCustom('company/globalcustomization/bytask', targetSplit);
  }

  getGlobalCustom(url:string, id:any){
    let that = this;
    let idUrl: string = id? id + (id.indexOf('?')===-1 ? '?' : '&') + 'landing=true' : 'null?landing=true';
    this.apiService.getNoBearer(url, idUrl)
      .then((data:any)=>{
        if(data.defaultCustomization){
          this.setFavicon(this.app.pagePreferences.fav);
        }else{
          let favicon = data?.favIcon?data.favIcon:null;
          this.configureCustomFavicon(favicon);
        }
      }, function(errorData){
        that.configureCustomFavicon(null);
      })
  }

  configureCustomFavicon(favicon:any){
    let that = this;
    let pagePreferences: any = this.app.pagePreferences;
    pagePreferences.fav = !favicon || favicon === null?pagePreferences.fav: URL.createObjectURL(this.commonUtilsService.baseToFormdata(this.commonUtilsService.setLogo(favicon,favicon), 'ico'));
    setTimeout(function(){
      that.setFavicon(pagePreferences.fav);
    })
  }

  setFavicon(favicon:any){
    let faviconElement: any = document.getElementById('favicon');
    faviconElement.href = favicon;
    // $('head').append('<link rel="shortcut icon" type="image/vnd.microsoft.icon" href="'+favicon+'"/>');
  }

  ngOnDestroy(){
    this.commonUtilsService.OnDestroy(this.subscribers);
    this.routerEventsService.unsubscribe();
  }
}
